import type React from 'react';
import clsx from 'clsx';

const DescriptionText: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = ({ children, className, ...props }) => (
  <p className={clsx('text-info-900 mt-2 text-sm', className)} {...props}>
    {children}
  </p>
);

export default DescriptionText;
